import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Types
import { RootProps } from './Root.types';

// Config
import { AppRouter } from './AppRouter';
import RouterSync from '@router/RouterSync';

// Components
import ErrorBoundary from '@views/error-boundary';

const Root = ({ store, persistor }: RootProps) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ErrorBoundary>
          <RouterSync />
          <AppRouter />
        </ErrorBoundary>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

export default Root;
